
window.addEventListener('CookiebotOnLoad', function() {
    let currentTimestamp = getTimestampInSeconds();
    let gcSessionId = 'gc'+ currentTimestamp + '.' + Math.random().toString(36).substring(5);
    if(!checkGCSessionId()) {
        setGCSessionId('_globalconnect_session_id', gcSessionId);
    }
});

function setGCSessionId(cname, cvalue) {
    const d = new Date();
    d.setTime(d.getTime() + (60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function checkGCSessionId() {
    let gc_session_id = getCookie("_globalconnect_session_id");
    if (gc_session_id != "") {
        return true;
    } else {
        return false;
    }
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function getTimestampInSeconds () {
    return Math.floor(Date.now() / 1000)
  }